import axios from "axios";

export type pedidoGeralDto = {
  id: string;
  pessoa_id: number;
  cliente_id: number;
  food_delivery_id: number;
  pedido: string;
  avaliado: boolean;
  created_at: string;
  updated_at: string;
  cliente: string;
  pessoa: string;
}

export type productsGeralDto = {
  item: {
    id: number;
    id_grupos: number;
    grupo: string;
    nome: string;
    descricao: string;
  };
  size: {
    id: number;
    id_produtos: number;
    id_tamanhos: number;
    tamanho: string;
    sabores: number;
    valor: number;
    acrescimos: any[]
    custo: number;
    gp_gratis_qtd_max: number;
    cod_barras: string;
    updated_at: string;
  };
  comments: string;
  additional: any[];
}

export const fetchAllPedidos = async (data_ini: string, data_fin: string, cliente_id?: number) => {
  const limit = 25;
  let allData: pedidoGeralDto[] = [];
  let cursor = 0;
  let keepGoing = true;

  while (keepGoing) {
    const response = await axios.get('https://apicontrole.dcifood.com.br/pessoas_pedido', {
      params: { 
        data_ini,
        data_fin,
        cursor,
        cliente_id,
        limit,
        order: "asc"
      }
    });

    const { lista, total } = response.data;
    allData = [...allData, ...lista];

    cursor += limit;
    keepGoing = allData.length < total;
  }

  return allData;
};
